export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8145.bcaf0645.jpg";